import { j as t } from "../../../../../../node_modules/react/jsx-runtime.js";
import { memo as B, useState as R, useCallback as h, useEffect as V } from "react";
import { Typography as k } from "../../../../../atoms/Typography/Typography.js";
import d from "../../../../../atoms/Button/Button.js";
import q from "../../../../../atoms/TextField/TextField.js";
import A from "../../../../Dropdown/Dropdown.js";
import G from "../../../../../atoms/ListItem/ListItem.js";
import g from "../../../../../atoms/Tooltip/Tooltip.js";
import { SortableList as T } from "../../../../../atoms/ListItem/SortableList/SortableList.js";
import { i18n as o } from "../../../../../../utils/locale/locale.js";
const H = ({
  columns: s,
  headerAdditionalControls: N,
  onColumnSort: n,
  onColumnDisplay: j,
  onDensityChange: f,
  onFullScreenClick: m,
  onExportChange: I,
  onFilterClick: w,
  onSearch: u,
  searchValue: _,
  searchPlaceholder: $,
  onClearFiltersClick: v,
  recordsCount: y,
  filters: r,
  isFullScreen: O,
  sortable: c,
  selectedDensity: x
}) => {
  const [z, b] = R(s ?? []), l = {
    variant: "ghost",
    color: "neutral",
    size: "small",
    iconOnly: !0
  }, E = h(
    (e) => {
      f && f(e);
    },
    [f]
  ), L = h(
    (e, i) => {
      n && j && (b(c ? (a) => a.map((p) => p.key === e ? { ...p, display: i } : p) : (s == null ? void 0 : s.map((a) => a.key === e ? { ...a, display: i } : a)) ?? []), j(e, i));
    },
    [n, j, c, s]
  ), M = h(
    (e) => {
      c && (b(e), n == null || n(e));
    },
    [c, n]
  ), P = h(
    ((e, i) => {
      let a;
      return function(...p) {
        a && clearTimeout(a), a = setTimeout(() => {
          e.apply(this, p);
        }, i);
      };
    })((e) => {
      u && u(e);
    }, 500),
    [u]
  );
  return V(() => {
    b(s ?? []);
  }, [s]), /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-025 justify-between", children: [
    /* @__PURE__ */ t.jsxs("div", { className: "flex gap-200 items-center w-1/2", children: [
      Number(y) > 0 && /* @__PURE__ */ t.jsxs("div", { className: "flex gap-050 flex-nowrap text-nowrap", children: [
        /* @__PURE__ */ t.jsx(
          k,
          {
            text: o("results_found"),
            variant: "interface/default/s",
            textColor: "color/fg/lightest"
          }
        ),
        /* @__PURE__ */ t.jsx(
          k,
          {
            text: y,
            variant: "interface/strong/s",
            textColor: "color/fg/bold"
          }
        )
      ] }),
      u && /* @__PURE__ */ t.jsx("div", { className: "w-full max-w-[480px]", children: /* @__PURE__ */ t.jsx(
        q,
        {
          placeholder: $ ?? o("search"),
          defaultValue: _,
          leadingIcon: "search-sm",
          onChange: P,
          size: "compact",
          testId: "table-controls-search-input"
        }
      ) })
    ] }),
    /* @__PURE__ */ t.jsxs("div", { className: "flex gap-050", children: [
      N,
      n && s && /* @__PURE__ */ t.jsx(
        A,
        {
          dropDownElement: /* @__PURE__ */ t.jsx(
            g,
            {
              trigger: /* @__PURE__ */ t.jsx(
                d,
                {
                  ...l,
                  leadingIcon: "columns-03",
                  testId: "table-controls-column-sort-button"
                }
              ),
              description: o("manage_columns")
            }
          ),
          withPortal: !0,
          stopDismiss: !0,
          position: "bottom-end",
          children: /* @__PURE__ */ t.jsx(
            T,
            {
              items: z,
              onChange: M,
              renderItem: (e) => /* @__PURE__ */ t.jsx(
                T.Item,
                {
                  id: e.id ?? e.key,
                  children: /* @__PURE__ */ t.jsx(
                    G,
                    {
                      ...e,
                      text: e.text ?? e.label ?? "",
                      value: e.id ?? e.key,
                      isSortable: c,
                      switch: {
                        active: e == null ? void 0 : e.display,
                        onChange: (i, a) => L(e.key, a)
                      },
                      testId: `table-controls-column-sort-${e.key}`
                    }
                  )
                },
                e.id ?? e.key
              )
            }
          )
        }
      ),
      f && x !== "auto" && /* @__PURE__ */ t.jsx(
        g,
        {
          trigger: /* @__PURE__ */ t.jsx(
            d,
            {
              ...l,
              testId: "table-controls-density-button",
              ...x && {
                leadingIcon: { relaxed: "rows-02", regular: "rows-03", condensed: "rows-04" }[x]
              },
              onClick: () => {
                x && E({
                  relaxed: "regular",
                  regular: "condensed",
                  condensed: "relaxed"
                }[x]);
              }
            }
          ),
          description: o("row_density")
        }
      ),
      m && /* @__PURE__ */ t.jsx(
        g,
        {
          trigger: /* @__PURE__ */ t.jsx(
            d,
            {
              ...l,
              onClick: m,
              leadingIcon: O ? "minimize-02" : "expand-06",
              testId: "table-controls-full-screen-button"
            }
          ),
          description: o("full_screen")
        }
      ),
      I && /* @__PURE__ */ t.jsx(
        g,
        {
          trigger: /* @__PURE__ */ t.jsx(
            d,
            {
              ...l,
              onClick: I,
              leadingIcon: "share-05",
              testId: "table-controls-export-button"
            }
          ),
          description: o("export")
        }
      ),
      (w || (r == null ? void 0 : r.length)) && /* @__PURE__ */ t.jsx(
        g,
        {
          trigger: /* @__PURE__ */ t.jsx(
            d,
            {
              ...l,
              onClick: w,
              leadingIcon: "filter-funnel-01",
              variant: "ghost",
              ...(r == null ? void 0 : r.length) && {
                iconOnly: !1,
                label: `${o("filtered_by")} ${r.slice(0, 2).join(", ")}  ${r.length > 2 ? `+${r.length - 2}` : ""}`,
                variant: "tinted"
              },
              testId: "table-controls-filter-button"
            }
          ),
          description: o("filter")
        }
      ),
      v && !!(r != null && r.length) && /* @__PURE__ */ t.jsx(
        d,
        {
          ...l,
          label: o("clear"),
          color: "primary",
          onClick: v,
          leadingIcon: "delete",
          iconOnly: !1,
          testId: "table-controls-clear-filters-button"
        }
      )
    ] })
  ] });
}, S = B(H);
export {
  S as default
};
//# sourceMappingURL=TableDefaultControls.js.map
